import React from "react";

const SafetyNote = () => {
  return (
    <div className="bg-gray-10 p-2  flex flex-col max-w-[355px] ">
      <p className="text-teal-300 text-sm  font-normal">
        Assess dose, frequency and for adverse effects. Additional review for
        "Safety" will be reviewed with the Profile Analysis engine at the end of
        review
      </p>
    </div>
  );
};

export default SafetyNote;
